// FORK_PATCH_BEGIN: account-public-id — centralize browser account identifiers
export const ACCOUNT_PUBLIC_ID_PATTERN = /^[a-km-np-z][a-km-np-z2-9]{9}$/;

export const normalizeAccountIdentifier = identifier =>
  typeof identifier === 'string' ? identifier.toLowerCase() : '';

export const isValidAccountIdentifier = identifier =>
  ACCOUNT_PUBLIC_ID_PATTERN.test(normalizeAccountIdentifier(identifier));

export const getAccountIdentifier = account => {
  const identifier = account?.public_id || account?.id;
  return isValidAccountIdentifier(identifier)
    ? normalizeAccountIdentifier(identifier)
    : null;
};

export const findAccountByIdentifier = (accounts, identifier) => {
  const normalizedIdentifier = normalizeAccountIdentifier(identifier);
  if (!isValidAccountIdentifier(normalizedIdentifier)) return undefined;

  return (accounts || []).find(
    account => getAccountIdentifier(account) === normalizedIdentifier
  );
};
// FORK_PATCH_END: account-public-id
